import React from 'react';

import { BaseCardProps } from '../types';

const CardLabel: React.FC<Pick<BaseCardProps, 'label'>> = (props) => {
  const { label } = props;

  if (!label) {
    return null;
  }

  return (
    <div className="Card__label__wrapper">
      <div className="Card__label">
        {label}
      </div>
    </div>
  );
};

export default CardLabel;
